import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';

import { Footer } from '@/components/layout/Footer/Footer';

import styles from './Terms.module.css';

export function Terms() {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Terminos y Condiciones — Ratio';
    }, []);

    return (
        <div className={styles.page}>
            <div className={styles.container}>
                <button
                    className={styles.backBtn}
                    onClick={() => navigate(-1)}
                    aria-label="Volver"
                >
                    <ArrowLeft size={18} />
                    Volver
                </button>

                <h1 className={styles.title}>Terminos y Condiciones</h1>
                <p className={styles.updated}>Ultima actualizacion: marzo 2026</p>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Uso aceptable</h2>
                    <p className={styles.text}>
                        Al utilizar Ratio, te comprometes a:
                    </p>
                    <ul className={styles.list}>
                        <li>No publicar contenido de spam o publicidad no solicitada</li>
                        <li>No publicar contenido ofensivo, discriminatorio o que incite al odio</li>
                        <li>No manipular los resultados de las votaciones mediante cuentas multiples u otros medios fraudulentos</li>
                        <li>No utilizar la plataforma para actividades ilegales o que violen los derechos de terceros</li>
                        <li>Respetar a los demas usuarios y mantener un dialogo constructivo</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Propiedad del contenido</h2>
                    <p className={styles.text}>
                        El contenido que publiques en Ratio (encuestas, comentarios, descripciones)
                        sigue siendo de tu propiedad. Sin embargo, al publicarlo, nos otorgas una
                        licencia no exclusiva para mostrarlo, distribuirlo y presentarlo dentro de
                        la plataforma.
                    </p>
                    <p className={styles.text}>
                        Esta licencia tiene como unico proposito el funcionamiento de la plataforma
                        y no implica cesion de derechos de autor.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Moderacion</h2>
                    <p className={styles.text}>
                        Nos reservamos el derecho de revisar, moderar y eliminar contenido que viole
                        estos terminos de uso. Esto incluye:
                    </p>
                    <ul className={styles.list}>
                        <li>Encuestas con contenido inapropiado u ofensivo</li>
                        <li>Comentarios que constituyan acoso o intimidacion</li>
                        <li>Contenido que difunda desinformacion verificable</li>
                        <li>Cuentas que participen en actividades fraudulentas</li>
                    </ul>
                    <p className={styles.text}>
                        Los usuarios pueden reportar contenido inapropiado. Los reportes seran
                        revisados por nuestro equipo de moderacion.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Limitacion de responsabilidad</h2>
                    <p className={styles.text}>
                        Ratio se proporciona &quot;tal cual&quot;, sin garantias de ningun tipo,
                        expresas o implicitas. No nos hacemos responsables de:
                    </p>
                    <ul className={styles.list}>
                        <li>El contenido publicado por los usuarios</li>
                        <li>La precision o veracidad de la informacion presentada en las encuestas</li>
                        <li>Interrupciones del servicio o perdida de datos</li>
                        <li>Danos directos o indirectos derivados del uso de la plataforma</li>
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Cambios a los terminos</h2>
                    <p className={styles.text}>
                        Nos reservamos el derecho de modificar estos terminos en cualquier momento.
                        Los cambios significativos seran notificados a traves de la plataforma.
                        El uso continuado de Ratio despues de la publicacion de cambios
                        constituye la aceptacion de los nuevos terminos.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Contacto</h2>
                    <p className={styles.text}>
                        Para preguntas sobre estos terminos y condiciones, contactanos en:{' '}
                        <a href="mailto:info@qolca.org" className={styles.link}>
                            info@qolca.org
                        </a>
                    </p>
                </section>
            </div>
            <Footer />
        </div>
    );
}
